export const DOC_CLASS_CATEGORIES = {
  SERVICES: 'fiche-innovation',
  MISCONCEPTION: 'idee-recue',
  RIGHT_NOW: 'article-veille',
  EVENT: 'fiche-evenement',
  INTERVIEW: 'article-podcast',
  CASE: 'article-grand-angle',
  LIFESPIRATION: 'article-grand-angle',
  POINT_OF_VIEW: 'eclairage',
  FOCUS: 'fiche-startup',
  KEYS_FIGURES: 'article-reperes',
  PORTRAIT: 'article-rencontre',
  INNER_PAGE: 'page-interne',
  PUBLICATION: 'publication',
};

const PRISMIC_CATEGORIES = {
  SERVICES: 'Innovation',
  MISCONCEPTION: 'Idée reçue',
  RIGHT_NOW: 'Veille',
  EVENT: 'Évènement',
  INTERVIEW: 'Podcast',
  CASE: 'Grand angle',
  LIFESPIRATION: 'Récit',
  POINT_OF_VIEW: 'Éclairage',
  FOCUS: 'Start-up',
  KEYS_FIGURES: 'Repères',
  PORTRAIT: 'Rencontre',
  INNER_PAGE: 'Page interne',
  PUBLICATION: 'Publication',
};

export const MAPPING_CLASS_CATEGORIES = {
  [PRISMIC_CATEGORIES.SERVICES]: DOC_CLASS_CATEGORIES.SERVICES,
  [PRISMIC_CATEGORIES.MISCONCEPTION]: DOC_CLASS_CATEGORIES.MISCONCEPTION,
  [PRISMIC_CATEGORIES.RIGHT_NOW]: DOC_CLASS_CATEGORIES.RIGHT_NOW,
  [PRISMIC_CATEGORIES.EVENT]: DOC_CLASS_CATEGORIES.EVENT,
  [PRISMIC_CATEGORIES.INTERVIEW]: DOC_CLASS_CATEGORIES.INTERVIEW,
  [PRISMIC_CATEGORIES.CASE]: DOC_CLASS_CATEGORIES.CASE,
  [PRISMIC_CATEGORIES.LIFESPIRATION]: DOC_CLASS_CATEGORIES.LIFESPIRATION,
  [PRISMIC_CATEGORIES.POINT_OF_VIEW]: DOC_CLASS_CATEGORIES.POINT_OF_VIEW,
  [PRISMIC_CATEGORIES.FOCUS]: DOC_CLASS_CATEGORIES.FOCUS,
  [PRISMIC_CATEGORIES.KEYS_FIGURES]: DOC_CLASS_CATEGORIES.KEYS_FIGURES,
  [PRISMIC_CATEGORIES.PORTRAIT]: DOC_CLASS_CATEGORIES.PORTRAIT,
  [PRISMIC_CATEGORIES.INNER_PAGE]: DOC_CLASS_CATEGORIES.INNER_PAGE,
  [PRISMIC_CATEGORIES.PUBLICATION]: DOC_CLASS_CATEGORIES.PUBLICATION,
};

export const DOC_CLASS_THEMATICS = {
  ECOLOGY: 'transition-ecologique',
  NUMERIQUE: 'numerique',
  PEOPLE: 'service-personne',
  BANK: 'action-publique',
  LOGISTICS: 'logistique',
  DT: 'developpement-territorial',
};

const PRISMIC_THEMATICS = {
  PEOPLE: 'Services à la personne',
  ECOLOGY: 'Transitions écologiques',
  NUMERIQUE: 'Transformation numérique',
  DT: 'Développement Territorial',
  BANK: 'Banque et assurance',
  LOGISTICS: 'Excellence logistique',
};

export const MAPPING_CLASS_THEMATICS = {
  [PRISMIC_THEMATICS.ECOLOGY]: DOC_CLASS_THEMATICS.ECOLOGY,
  [PRISMIC_THEMATICS.NUMERIQUE]: DOC_CLASS_THEMATICS.NUMERIQUE,
  [PRISMIC_THEMATICS.PEOPLE]: DOC_CLASS_THEMATICS.PEOPLE,
  [PRISMIC_THEMATICS.BANK]: DOC_CLASS_THEMATICS.BANK,
  [PRISMIC_THEMATICS.LOGISTICS]: DOC_CLASS_THEMATICS.LOGISTICS,
  [PRISMIC_THEMATICS.DT]: DOC_CLASS_THEMATICS.DT,
};
